<template>
	<div>
		<div class="post-form">
	        <h1 class="heading">{{ title_ja }}応募フォーム</h1>
            <input type="hidden" name="post_info_id" value="">

            <div v-if="namelist.includes('mail')">
            <div class="mypage-title">
			メールアドレス
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                    <input type="text" class="form-control" v-model="mail" name="mail" id="mail" value="">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('name')">
            <div class="mypage-title">
			氏名
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                    <input type="text" class="form-control" v-model="name" name="name" id="name" value="">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('name_kana')">
            <div class="mypage-title">
			氏名（ふりがな）
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                    <input type="text" class="form-control" v-model="name_kana" name="name_kana" id="name_kana" value="">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('postnum')">
            <div class="mypage-title">
			郵便番号
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                    <input type="text" class="form-control" v-model="postnum"  name="postnum" id="postnum" value="">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('address')">
            <div class="mypage-title">
			住所
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                    <input type="text" class="form-control" v-model="address"  name="address" id="address" value="">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('birth')">
            <div class="mypage-title">
			生年月日
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                    <input type="text" class="form-control" v-model="birth"  name="birth" id="birth" value="">
                </div>
            </div>
            </div>
			
            <div v-if="namelist.includes('tel')">
            <div class="mypage-title">
			電話番号
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                    <input type="text" class="form-control" v-model="tel"  name="tel" id="tel" value="">
                </div>
            </div>
            </div>
			
            <div v-if="namelist.includes('identification_path_1')">
            <div class="mypage-title">
			身分証明書
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                    <input type="file" name="identification_path_1">
                </div>
                <div class="form-group col" v-if="namelist.includes('identification_path_2')">
                    <input type="file" name="identification_path_2">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('self_introduce')">
            <div class="mypage-title">
			自己紹介（400文字程度）
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                <textarea class="form-control" v-model="self_introduce" name="self_introduce" id="self_introduce"></textarea>
                </div>
            </div>
            </div>
			
            <div v-if="namelist.includes('motivation')">
            <div class="mypage-title">
			志望動機（400字程度）
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
                <textarea class="form-control" v-model="motivation" name="motivation" id="motivation"></textarea>
                </div>
            </div>
            </div>
			
            <div v-if="namelist.includes('goal')">
            <div class="mypage-title">
			アニメ業界での目標（400字程度）
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<textarea class="form-control" v-model="goal" name="goal" id="goal"></textarea>
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('remarks')">
            <div class="mypage-title">
			特記事項（趣味・特技・資格・受賞歴など）
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<textarea class="form-control" v-model="remarks" name="remarks" id="remarks"></textarea>
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('affected_titles')">
            <div class="mypage-title">
			影響を受けたアニメ作品
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<textarea class="form-control" v-model="affected_titles" name="affected_titles" id="affected_titles"></textarea>
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('name_showable_status')">
            <div class="mypage-title">
			番組内での本名の使用可否
            </div>
            <div class="myinfo-item form-check form-check-inline">
                <div class="form-group col">
				<input type="radio" class="form-control" v-model="name_showable_status" name="name_showable_status" id="name_showable_status" value="1">OK
                </div>
                <div class="form-group col">
				<input type="radio" class="form-control" v-model="name_showable_status" name="name_showable_status" id="name_showable_status" value="0">NG
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pen_name')">
            <div class="mypage-title">
			番組内での本名の使用可否が「NG」の場合、利用したい名前またはペンネーム
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="text" class="form-control" v-model="pen_name" name="pen_name" id="pen_name" value="">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('difficult_time')">
            <div class="mypage-title">
			2022年1月～3月の間で、「アニメ制作に集中して時間を割くことが難しい時期」について、ご記入ください。
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<textarea class="form-control" v-model="difficult_time" name="difficult_time" id=""></textarea>
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pf1_1')">
            <div class="mypage-title">
			作品（ラフデッサン）　※A4/2枚、画像orPDF
            </div>
            <div class="myinfo-item form-row">
				<div class="form-group col">
				<input type="file" name="pf1_1">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pf2_1')">
            <div class="mypage-title">
			得意・やりたい事を表すデザイン3種 ※画像orPDF
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="file" name="pf2_1">
				</div>
            </div>
            </div>

            <div v-if="namelist.includes('pf3_1')">
            <div class="mypage-title">
			得意・やりたい事を表すデザイン3種の説明 ※PDF
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="file" name="pf3_1">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pf4_1')">
            <div class="mypage-title">
			提出したキャラクターの三面図3種 ※画像orPDF
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="file" name="pf4_1">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pf5_1')">
            <div class="mypage-title">
			作品（映像or絵コンテ） ※動画ファイルアップロード
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="file" name="pf5_1">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pf6_1')">
            <div class="mypage-title">
			作品の内容説明（A4/1枚以内、400字程度） ※PDF
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="file" name="pf6_1">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pf7_1')">
            <div class="mypage-title">
			作品（脚本）　※A4/1枚、2000字以内 PDF
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="file" name="pf7_1">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pf8_1')">
            <div class="mypage-title">
			脚本の登場人物、世界観の設定　※A4/1枚、2000字以内 PDF
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="file" name="pf8_1">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pf9_1')">
            <div class="mypage-title">
			脚本の冒頭第1話　※A4、最大30枚以内、PDF
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="file" name="pf9_1">
                </div>
            </div>
            </div>

            <div v-if="namelist.includes('pf10_1')">
            <div class="mypage-title">
			脚本の冒頭第2話　※A4、最大30枚以内、PDF
            </div>
            <div class="myinfo-item form-row">
                <div class="form-group col">
				<input type="file" name="pf10_1">
                </div>
            </div>
            </div>

            <section id="buttons" class="d-flex justify-content-center">
                <button class="btn btn-dark button" @click="post_apply()"> 応募する </button>
            </section>
		</div>
	</div>
</template>

<script>
    export default {
        name: "post-form",
        props: ['json_characters', 'post_info_id', 'title_ja', 'json_namelist'],
        data() {
            return {
                name_showable_status:0,
                namelist:[],
                processing: false,
            }
        },
        mounted() {
            axios.default
                .get('/login/get')
                .then(response => {
                    this.loginStatus = response.data;
                });
            this.characters = JSON.parse(this.json_characters);
            this.namelist = JSON.parse(this.json_namelist);
        },
        methods: {
            pdata(params,key,ele) {
                if( ele!=undefined ) {
                    params.append(key,ele);
                }
            },
            post_apply() {
                if(this.loginStatus === false) {
                    this.loginModal=true;
                } else {
                    if (this.processing) {
                        console.log('processing');
                        return;
                    }
                    this.processing = true;
                    var headers = { "content-type": "multipart/form-data" };
                    var params = new FormData();
                    params.append('post_info_id', this.post_info_id);
                    this.pdata(params,'namelist',JSON.stringify(this.namelist));
                    this.pdata(params,'mail',this.mail);
                    this.pdata(params,'name',this.name);
                    this.pdata(params,'name_kana',this.name_kana);
                    this.pdata(params,'postnum',this.postnum);
                    this.pdata(params,'address',this.address);
                    this.pdata(params,'birth',this.birth);
                    this.pdata(params,'tel',this.tel);
                    this.pdata(params,'self_introduce',this.self_introduce);
                    this.pdata(params,'motivation',this.motivation);
                    this.pdata(params,'goal',this.goal);
                    this.pdata(params,'remarks',this.remarks);
                    this.pdata(params,'affected_titles',this.affected_titles);
                    this.pdata(params,'name_showable_status',this.name_showable_status);
                    this.pdata(params,'pen_name',this.pen_name);
                    var id1_Dom = $('[name=\'identification_path_1\']')[0];
                    if( id1_Dom!=undefined ) {
                        this.pdata(params,'identification_path_1', id1_Dom.files[0]);
                    }
                    var id2_Dom = $('[name=\'identification_path_2\']')[0];
                    if( id2_Dom!=undefined ) {
                        this.pdata(params,'identification_path_2', id2_Dom.files[0]);
                    }
                    var pf_list=['pf1_1','pf2_1','pf3_1','pf4_1','pf5_1','pf6_1','pf7_1','pf8_1','pf9_1','pf10_1'];
                    pf_list.forEach(pf_key => {
                        var pf_Dom = $('[name=\''+pf_key+'\']')[0];
                        if( pf_Dom!=undefined ) {
                            this.pdata(params, pf_key, pf_Dom.files[0]);
                        }
                    });
                    /*
                    var pf1_1_Dom = $('[name=\'pf1_1\']')[0];
                    this.pdata(params,'pf1_1', pf1_1_Dom.files[0]);
                    var pf2_1_Dom = $('[name=\'pf2_1\']')[0];
                    this.pdata(params,'pf2_1', pf2_1_Dom.files[0]);
                    var pf3_1_Dom = $('[name=\'pf3_1\']')[0];
                    this.pdata(params,'pf3_1', pf3_1_Dom.files[0]);
                    */
                    try{
                        axios.default
                            .post('/post-upd', params, { headers })
                            .then((response) => {
                                if(response.data.error_kind) {
                                    this.getErrorContent(response.data);
                                    this.processing = false;
                                } else {
                                    //alert('登録が完了しました。');
                                    this.processing = false;
                                    location.href="/post-end?post_info_id="+this.post_info_id;
                                }
                            },()=>{
                                alert('ブラウザからの送信がタイムアウトしました。');
                                this.processing = false;
                            });
                    }
                    catch (e) {
                        alert('ブラウザからの送信でエラーが発生しました。');
                        this.processing = false;
                        if (Axios.isAxiosError(e)) {
                            if (e.response && e.response.status === 400) {
                                console.log(e.message);
                            }
                            else {
                                console.log(e.response.status);
                                console.log(e);
                            }
                        }
                        else {
                            console.log(e);
                        }
                    }
                }
            },
            closeModal: function() {
                this.loginModal=false;
            },
            getErrorContent: function(data) {
                let error_kind = data.error_kind
                if( data.message ) {
                    alert(data.message);
                }
                else {
                    alert(this.characters[error_kind]);
                }
            },
        },
        watch: {
        }
    }
</script>

<style scoped>
</style>
